import React from 'react';
import { useFormContext } from 'react-hook-form';
import { InputField } from '../InputField';
import { ErrorMsg } from '../ErrorMsg';

import styles from './styles.module.scss';

/**
 * Checkbox component for form fields.
 *
 * @param {object} props - Component props.
 * @param {string} props.name - Name of the checkbox field.
 * @param {React.ReactNode} props.children - Children to render next to the checkbox.
 * @returns {JSX.Element} The rendered Checkbox component.
 */
const Checkbox = ({
  name, children, ...props
}) => {
  const {
    formState: { errors },
  } = useFormContext();

  return (
    <div className={styles.container} data-testid="checkbox-container">
      <ErrorMsg message={errors[name]?.message} className={styles.error} />
      <div className={styles.checkboxContainer}>
        <InputField
          type="checkbox"
          name={name}
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...props}
        />
        <div>{children}</div>
      </div>
    </div>
  );
};

export { Checkbox };
